import {Component} from 'react';
import {Header, Segment} from 'semantic-ui-react';
import TitleDescription from './TitleDescription';
import TitleLegalDescriptions from './TitleLegalDescriptions';
import TitleOwners from './TitleOwners';
import TitleInterests from './TitleInterests';
import Disclaimers from './Disclaimers';
import PropTypes from 'prop-types';
import moment from 'moment';
import './CustomiseNzTitles.scss';

export class CustomiseNzTitles extends Component {
  static propTypes = {
    titles: PropTypes.array.isRequired,
    disclaimers: PropTypes.shape({
      clPublicationNz: PropTypes.string,
      clDataNz: PropTypes.string,
      titleNz: PropTypes.string
    }),
  };

  render() {
    const {
      titles,
      disclaimers,
    } = this.props;

    return (
      <div className="customise-title">
        <Header as="h2" className="section-type" style={{fontWeight: 'bold'}} disabled>Title Details</Header>
        <Segment style={{padding: '30px'}}>
          <Header as="h2" className="title-header">Title Details</Header>
          <div>Up to date as of {moment(new Date()).format('DD MMMM YYYY')}</div>
          {titles.map(title => (
              <div key={title.titleDescription.reference} style={{display: 'block'}}>
                <hr/>
                <TitleDescription titleDescription={title.titleDescription}/>
                <TitleLegalDescriptions legalDescriptions={title.legalDescriptions}/>
                <TitleOwners owners={title.owners}/>
                <TitleInterests interests={title.interests}/>
              </div>
            )
          )}
          {titles.length > 0 && disclaimers &&
            <span>
              <hr/>
              <Disclaimers disclaimers={disclaimers}/>
            </span>
          }
        </Segment>
      </div>
    );
  }
}

export default CustomiseNzTitles;
